const ERRORS = {
  'auth/invalid-email': 'Invalid email address.',
  'auth/user-disabled': 'Your profile is disabled. Please mail to insideinsight.co for furthur details.',
  'auth/user-not-found': 'Email/Username not found.',
  'auth/wrong-password': 'Wrong password.',
  'auth/weak-password': 'Password should be at least 6 characters',
  'auth/operation-not-allowed': 'Please contact support for Guest Sign In access',
  'Username is not found': 'Please check the url and try Sign In. Happening again? Contact support.',
};

export default ERRORS;



// WEBPACK FOOTER //
// ./src/constants/firebase.js